import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { LinkButton } from '@guardian/source-react-components';
const widthOverride = css `
	iframe {
		min-width: 300px !important;
		max-width: 100%;
	}
`;
export const getDocumentCloudAssetUrl = (embedUrl) => {
    return (embedUrl &&
        embedUrl.replace(new RegExp('https://embed.documentcloud.org/documents/([0-9]+)-([^/]+).*', 'g'), 'https://assets.documentcloud.org/documents/$1/$2.pdf'));
};
export const DocumentBlockComponent = ({ embedUrl, title, width, height, source }) => {
    return (_jsxs("div", Object.assign({ css: widthOverride }, { children: [_jsx("iframe", { src: embedUrl, title: title, height: height, width: width, allowFullScreen: true, "data-cy": "document-embed" }, void 0), source === 'DocumentCloud' ? (_jsx(LinkButton, Object.assign({ priority: "subdued", size: "small", href: getDocumentCloudAssetUrl(embedUrl), title: title, download: true }, { children: "Download original document" }), void 0)) : (_jsx(_Fragment, {}, void 0))] }), void 0));
};
